module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_3009.9494ae06.png";